export default "__VITE_ASSET__BW_U2b0x__"